<script>
import DialogDate from '../components/DialogDate'
import GroupList from '../components/GroupList'

export default {
  name: 'FormCISTask',
  
  components: {
    DialogDate,
    GroupList

  },

  data () {
    return {
      title: 'CIS-Aufträge',
      table: 'cis_task',
      mainview: 'ListCISTasks',
      id: '',
      date: '',
      company: '',
      street: '',
      zipcode: '',
      city: '',
      email: '',
      document_no: '',
      execution_date: '',
      execution_period: '',
      status: '',
      note: '',
      taskItems: [] ,
      rest_qty: '',
      componentKey: 0,
     
      isReleased: 0,
      values_article: [

        {
          name: 'Artikel',
          text:  'article_name',
          value:  'article_id',
          required: true,
          typ: 'select',
          select_table: 'article',
          select_text: 'name',
          select_value: 'id',
          select_label: 'Artikel',
        },
        {
          name: 'Stückzahl',
          value:  'order_qty',
          required: true,
          typ: 'text'
        },
      ],

    }
  },
  async created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      await this.fetchTask()
    }
  },

  methods: {
    async fetchTask()  {
      console.log('fetching cis task...')
      var param = {
        table: this.table,
        statement: "select",
        type: "detail",
        where: "true",
        selector: "id",
        value: this.id,
        short: "true",
        extention: ""
      }
      var data = {}
      var result = await this.$func.queryAPI(param, data)
      console.log("cis taskssss",result)
      const formatDate = (isoDate) => {
       if (!isoDate) return '';
       const date = new Date(isoDate);
       const day = String(date.getDate()).padStart(2, '0');
       const month = String(date.getMonth() + 1).padStart(2, '0'); 
       const year = date.getFullYear();
       return `${day}.${month}.${year}`;
      };
      this.isReleased = result[0].is_released;
      console.log('isReleased value:', this.isReleased);
      this.date = result[0].date ? formatDate(result[0].date) : '';
      this.company = result[0].company
      this.street = result[0].street
      this.zipcode = result[0].zipcode
      this.city = result[0].city
      this.email = result[0].email
      this.document_no = result[0].document_no
      this.execution_date = result[0].execution_date ? formatDate(result[0].execution_date) : '';
      this.execution_period = result[0].execution_period
      this.status = result[0].status
      this.note = result[0].note
      


      const itemParam = {
       table: 'cis_task_items',
       statement: "select",
       type: "list",
       where: "true",
       selector : "temp_task_id",
       value: this.id,
       short: "true",
       extention: ""
     };
     var itemData = {};
     var itemResult = await this.$func.queryAPI(itemParam, itemData);
     console.log("cis task items:", itemResult);
     this.taskItems = itemResult;

    },

    async updateCisTask() {
      console.log('updating cis task...')

      var param = {
        table: this.table,
        statement: "update",
        type: "detail",
        where: "true",
        selector: "id",
        value: this.id,
        short: "true",
        extention: ""
      }
      const formatDate = (date) => {
        if (!date) return '';
        const [day, month, year] = date.split('.');
        return `${year}-${month}-${day}`;
      };
      var data = {
        date: this.date ? formatDate(this.date) : '',
        company: this.company,
        street: this.street,
        zipcode: this.zipcode,
        city: this.city,
        email: this.email,
        document_no: this.document_no,
        execution_date: this.execution_date ? formatDate(this.execution_date) : '',
        execution_period: this.execution_period,
        status: this.status,
        note: this.note
      }
      var result = await this.$func.queryAPI(param, data)
      console.log(result)
      this.$router.push({ name: this.mainview })
    },
    
    btnCancel(){
      this.$router.push({ name: this.mainview })
    },

    async releaseCisTask() {
      console.log('releasing cis task...');
  
      const formatDateTime = (isoDateTime) => {
        if (!isoDateTime) return '';
         const date = new Date(isoDateTime);
         const year = date.getFullYear();
         const month = String(date.getMonth() + 1).padStart(2, '0');
         const day = String(date.getDate()).padStart(2, '0');
         const hours = String(date.getHours()).padStart(2, '0');
         const minutes = String(date.getMinutes()).padStart(2, '0');
         const seconds = String(date.getSeconds()).padStart(2, '0');
         return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };

  
      const formatDateDDMMYYYY = (isoDateTime) => {
         if (!isoDateTime) return '';
           const date = new Date(isoDateTime);
           const day = String(date.getDate()).padStart(2, '0');
           const month = String(date.getMonth() + 1).padStart(2, '0');
           const year = date.getFullYear();
         return `${day}.${month}.${year}`;
       };
  // Step 1: fetch the current CIS task data
  const cisTaskParam = {
    table: this.table,
    statement: "select",
    type: "detail",
    where: "true",
    selector: "id",
    value: this.id,
    short: "true",
    extention: ""
   };

   const cisTaskData = {};
   const cisTaskResult = await this.$func.queryAPI(cisTaskParam, cisTaskData);
    console.log('CIS Task Data:', cisTaskResult);

    if (cisTaskResult && cisTaskResult.length > 0) {
     const cisTask = cisTaskResult[0];

    // Step 2: Check if a task with the same customer company already exists
    const checkTaskParam = {
      table: 'task',
      statement: "select",
      type: "detail",
      where: "true",
      selector: "company",
      value: cisTask.company,
      short: "true",
      extention: ""
    };

    const existingTasks = await this.$func.queryAPI(checkTaskParam, {});
    console.log('Existing Tasks:', existingTasks);

    if (existingTasks && existingTasks.length > 0) {
      console.error('A task with the same customer company already exists.');
      alert('A task with the same customer company already exists. Cannot release the CIS task.');
      return;
    }

    // Step 3: Create a new task in the `task` table with data from the CIS task
    const createTaskParam = {
      table: 'task',
      statement: "insert",
      type: "detail",
      short: "false",
      extention: ""
    };

     
    const formattedDate = formatDateDDMMYYYY(cisTask.date);
    const formattedExecutionDate = formatDateDDMMYYYY(cisTask.execution_date);

    const taskData = {
      worker: 'cis',
      cis_task_id: cisTask.id,
      date: formattedDate || '',
      //execution_period: cisTask.execution_period || '',
      execution_date: formattedExecutionDate || '',
      company: cisTask.company || '',
      street: cisTask.street || '',
      zipcode: cisTask.zipcode || '',
      city: cisTask.city || '',
      email: cisTask.email || '',
      note: cisTask.note || '',
      cis_note: cisTask.note || '',
      document_no: cisTask.document_no || '',
      cis_user_id: cisTask.cis_user_id || '',
    };

    const createTaskResult = await this.$func.queryAPI(createTaskParam, taskData);
    console.log('New task created:', createTaskResult);

    
    if (createTaskResult && createTaskResult.value) {
      const newTaskId = createTaskResult.value;

      // Step 4: Update the `task_id` in the `cis_task` table
      const updateCisTaskParam = {
        table: this.table,
        statement: "update",
        type: "detail",
        where: "true",
        selector: "id",
        value: this.id,
        short: "true",
        extention: ""
      };

      const updateCisTaskData = {
        status: 'released',
        is_released: 1,
        released_at: formatDateTime(new Date()),
        released_by: localStorage.username,
        task_id: newTaskId
      };

      const updateCisTaskResult = await this.$func.queryAPI(updateCisTaskParam, updateCisTaskData);
      console.log('CIS task updated:', updateCisTaskResult);

      this.isReleased = 1;
      this.$router.push({ name: this.mainview });
    } else {
      console.error('Failed to create a new task. API Response:', createTaskResult);
    }
  } else {
    console.error('Failed to fetch CIS task data.');
  }
},

  }
}




</script>

<template>
  <v-layout>
    <v-card 
      class="mx-auto justify-center text-center"
      width="600"
      style="padding-top: 30px;"
      elevation="10"
    >
      <v-card-title primary-title class="justify-center">
        <div>
          <h3 class="headline text--accent-2">{{ this.title }}</h3>
        </div>
      </v-card-title>

      <v-form>
        <DialogDate
          v-bind:label="'Datum'"
          v-bind:initial_date="date"
          v-model="date"
          :key="date"
      
        ></DialogDate>

        <v-text-field
          v-model="company"
          label="Kunde"
          outlined
          type="text"
          autocomplete="off"
          class="form-field"
        />

        <v-text-field
          v-model="street"
          label="Strasse"
          outlined
          type="text"
          autocomplete="off"
          class="form-field"
        />

        <v-text-field
          v-model="zipcode"
          label="PLZ"
          outlined
          type="text"
          autocomplete="off"
          class="form-field"
        />

        <v-text-field
          v-model="city"
          label="Stadt"
          outlined
          type="text"
          autocomplete="off"
          class="form-field"
        />

        <v-text-field
          v-model="email"
          label="Email"
          outlined
          type="email"
          autocomplete="off"
          class="form-field"
        />

        <v-text-field
          v-model="document_no"
          label="Document No."
          outlined
          type="text"
          autocomplete="off"
          class="form-field"
        />

        <DialogDate
          v-bind:label="'Auftragsdatum'"
          v-bind:initial_date="execution_date"
          v-bind:clearable="true"
          v-model="execution_date"
          :key="execution_date"
        ></DialogDate>

        <v-text-field
          v-model="execution_period"
          label="AUSFÜHRUNGSFRIST"
          outlined
          type="text"
          autocomplete="off"
          class="form-field"
        />
        <GroupList
         
          v-bind:title="'Artikel zum abholen'"
          v-bind:table="'cis_task_items'"
          v-bind:temp_task_id="id"  
          v-bind:customer_id="''"
          v-bind:group_type_id="''"
          v-bind:rest_qty="rest_qty"
          v-bind:values="values_article"
          v-bind:elevation="'0'"
        />
        <div
            style="padding: 10px;"
        ></div>

        <v-textarea
          v-model="note"
          outlined
          label="Bemerkungen"
          class="form-field"
        />
        <v-row class="my-3 mx-2 ">
          <v-col class="text-left">
          <v-btn 
            color="purple"
            elevation="2"
            outlined
            @click = "releaseCisTask"
            v-if="status === 'active'"
             
          
          >
          freigeben
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-btn
            color="red"
            elevation="2"
            outlined
            class="mr-4"
            @click="btnCancel"
          >
          Abbrechen

          </v-btn>

          <v-btn
              v-if="status === 'active'"
            color="green"
            elevation="2"
            outlined
            @click="updateCisTask"
          >
          Speichern
          </v-btn>
        </v-col>
   
        </v-row>
      </v-form>
    </v-card>
  </v-layout>
</template>



<style scoped>
.form-field {
  display: table;
  margin: 0 auto;
  width: 350px;
}
</style>